module.exports = __webpack_public_path__ + "img/selected5-min.8b1b2666.png";